export default class I9 {
    constructor(data) {
        const { id, worker_user_id, worker_contractor_id, worker_i9_fields, witness_user_id, witness_job_title, witness_business_name } = data;
        let { A, B, C } = worker_i9_fields;

        this.id = id;
        this.worker_user_id = worker_user_id;
        this.worker_contractor_id = worker_contractor_id;
        this.worker_i9_fields = { ...worker_i9_fields, A, B, C };

        this.witness_user_id = witness_user_id;
        this.witness_job_title = witness_job_title;
        this.witness_business_name = witness_business_name;
    }
}



// WEBPACK FOOTER //
// ./src/models/i9.jsx